import { render, staticRenderFns } from "./ScrollyViewport.vue?vue&type=template&id=6844724e"
import script from "./ScrollyViewport.vue?vue&type=script&lang=js"
export * from "./ScrollyViewport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports